import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { INotification } from "infrastructure/notification";
import { actionProcessing } from "infrastructure/store";
import { getScreenExtraReducers } from "ui/app";

import { IMessagesState, IMessagesFilter, getInitialMessagesState, IMessageItem, IMessagesSearchQuery } from "./Messages.state";

const initialState = getInitialMessagesState();

export const messagesManager = createSlice({
  name: "messages",
  initialState: initialState,
  reducers: {
    loadingFailed: (state: IMessagesState, action: PayloadAction<INotification>) => {
      state.filter.messageId = "";
      state.filter.text = "";
      state.notifications.push(action.payload);
      return state;
    },
    initialize: state => {
      return {
        ...state,
        isLoading: true
      };
    },
    initializeCompleted: (state, action: PayloadAction<IMessagesFilter>) => {
      return {
        ...state,
        isLoading: false,
        filter: action.payload
      };
    },
    searchMessages: actionProcessing.createWithClearNotification((state: IMessagesState, action: PayloadAction<IMessagesSearchQuery>) => {
      return {
        ...state,
        searchQuery: action.payload,
        isLoading: true
      };
    }),
    searchMessagesCompleted: (state, action: PayloadAction<IMessageItem[]>) => {
      return {
        ...state,
        isLoading: false,
        grid: {
          ...state.grid,
          gridData: action.payload,
          selected: "",
          isSearched: true
        },
        isExportDisabled: action.payload.length === 0
      };
    },
    toggleSelection: (state: IMessagesState, action: PayloadAction<string>) => {
      return {
        ...state,
        grid: {
          ...state.grid,
          selected: action.payload
        }
      };
    },
    uploadMessages: (state: IMessagesState, _action: PayloadAction<File[]>) => {
      return {
        ...state,
        isLoading: true,
        messagesUploadingState: {
          uploadingProcessing: true,
          uploadCompleted: false,
          validationIssues: []
        }
      };
    },
    resetUploadingMessages: (state: IMessagesState) => {
      return {
        ...state,
        isLoading: false,
        translationsUploadingState: {
          uploadingProcessing: false,
          uploadCompleted: false,
          validationIssues: []
        }
      };
    },
    exportMessagesToXml: actionProcessing.createWithClearNotification((state: IMessagesState, action: PayloadAction<IMessagesSearchQuery>) => {
      return {
        ...state,
        searchQuery: action.payload
      };
    }),
    exportMessagesFailed: (state: IMessagesState, action: PayloadAction<INotification>) => {
      return {
        ...state,
        notifications: [...state.notifications, action.payload]
      };
    },
    downloadMessagesUploadTemplate: (state: IMessagesState) => {
      return {
        ...state
      };
    },
    onMessagesUploadCompleted: (state, action: PayloadAction<INotification>) => {
      return {
        ...state,
        notifications: [action.payload]
      };
    }
  },
  extraReducers: getScreenExtraReducers<IMessagesState>("notifications", initialState)
});
